import { render, staticRenderFns } from "./DocumentacionesAduaneras.vue?vue&type=template&id=d94d9748&scoped=true&"
import script from "./DocumentacionesAduaneras.vue?vue&type=script&lang=js&"
export * from "./DocumentacionesAduaneras.vue?vue&type=script&lang=js&"
import style0 from "./DocumentacionesAduaneras.vue?vue&type=style&index=0&id=d94d9748&lang=scss&scoped=true&"
import style1 from "./DocumentacionesAduaneras.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d94d9748",
  null
  
)

export default component.exports